document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      $('.text-box').addClass('normalmove02');
    }, 200);

    $(window).scroll(function () {
      if ($(window).scrollTop() + ($(window).height() * 2) / 3 + 500 > $('.block01').offset().top) {
        $('.block01').addClass('normalmove');
      } else {
        $('.block01').removeClass('normalmove');
      }
      if ($(window).scrollTop() + ($(window).height() * 2) / 3 + 500 > $('.bottom-box').offset().top) {
        $('.bottom-box').addClass('normalmove');
      } else {
        $('.bottom-box').removeClass('normalmove');
      }
    });
  });